export enum AttendenceType {
  online = 'online_care',
  home = 'home_care',
}
